import PropTypes from "prop-types";
import React from "react";

import { Switch } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes all
import {
  organizationRoutes,
  userRoutes,
  authRoutes,
  customRoutes,
  oneTimeRoute,
  errorRoutes,
  recruiterRoute,
  feedBackRoutes,
} from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/Layout/";
import HorizontalNonAuthLayout from "./components/Layout/HorizontalLayout";
import HorizontalLayout from "./components/HorizontalLayout2";
import NonAuthLayout from "./components/Layout/nonauth/NonAuthLayout";
import FeedbackLayout from "./components/Layout/feedback/feedback-layout";
// Import scss
import "./assets/scss/theme.scss";
import { AuthProvider } from "./context/AuthContext";
import AppLoader from "./components/Common/AppLoader";

const App = (props) => {
  function getLayout() {
    if (props?.layout?.layoutType === "horizontal") {
      return HorizontalLayout;
    }
    return VerticalLayout;
  }

  const Layout = getLayout();
  return (
    <AuthProvider>
      <React.Suspense fallback={<AppLoader />}>
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
            />
          ))}
          {feedBackRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={FeedbackLayout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
            />
          ))}

          {userRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
              exact
            />
          ))}

          {organizationRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
              exact
            />
          ))}

          {customRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
              exact
            />
          ))}
          {oneTimeRoute.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={HorizontalNonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
              exact
            />
          ))}
          {errorRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
              exact
            />
          ))}
          {recruiterRoute.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={JSON.parse(
                localStorage.getItem("isAuthProtected"),
              )}
              exact
            />
          ))}
        </Switch>
      </React.Suspense>
    </AuthProvider>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
